var client = "";

var localTerm = "localhost";

var BASE_URL = "";
var BASE_READER = { vod: "", live: "" };
var EMBED_URL = window.location.origin + "/embeded";
var BASE_EXPORT = window.location.origin + "/export";
var BASE_RTC = window.location.origin.replace("https", "wss") + "/livestream/";
var BASE_VIREED = "/apivireed";
var WS_VIREED = "";
var WS_CHAT = "";
var WS_CHAT_PATH = "/chat/socket.io";
var WS_CHAT_LIVE = "";
var WS_CHAT_LIVE_PATH = "/chat-live/socket.io";
var RTMP_URL =  window.location.origin.replace("https", "rtmp") + "/live";
var PREVIEW_RTMP_URL = "/preview/";

if (client !== "" && client !== "local") {
    BASE_URL = `https://${client}.quanteec.com`;
    BASE_READER = { vod: BASE_URL, live: BASE_URL };
    EMBED_URL = BASE_URL + "/embeded";
    BASE_EXPORT = BASE_URL + "/export";
    BASE_RTC = BASE_URL.replace("https", "wss") + "/livestream/";
    BASE_VIREED = BASE_URL + '/apivireed';
    WS_VIREED = BASE_URL;
    WS_CHAT = BASE_URL;
    WS_CHAT_PATH = "/chat/socket.io";
    WS_CHAT_LIVE = "BASE_URL";
    WS_CHAT_LIVE_PATH = "/chat-live/socket.io";
    RTMP_URL = BASE_URL.replace("https", "rtmp") + "/live/";
    PREVIEW_RTMP_URL = BASE_URL + "/preview/";
} else if (client !== "" && client === "local") {
    BASE_URL = `http://${localTerm}:8000`;
    BASE_READER = { vod: `http://${localTerm}:8000`, live: `http://${localTerm}:8000` };
    EMBED_URL = `http://${localTerm}:8089/embeded`;
    BASE_EXPORT = `http://${localTerm}:8089/export`;
    BASE_RTC = `ws://${localTerm}:3016/`;
    BASE_VIREED = `http://${localTerm}:8081`;
    WS_VIREED = `ws://${localTerm}:8081`;
    WS_CHAT = `ws://${localTerm}:8082`;
    WS_CHAT_PATH = "/chat/socket.io";
    WS_CHAT_LIVE = `ws://${localTerm}:8093`;
    WS_CHAT_LIVE_PATH = "/chat-live/socket.io";
    RTMP_URL = `rtmp://${localTerm}/live/`;
    PREVIEW_RTMP_URL = `http://${localTerm}:8081/preview`;
}


export { BASE_URL, BASE_READER, EMBED_URL, BASE_EXPORT, BASE_RTC, BASE_VIREED, WS_CHAT, WS_CHAT_PATH, WS_VIREED, WS_CHAT_LIVE, WS_CHAT_LIVE_PATH, RTMP_URL, PREVIEW_RTMP_URL }
